/* fndry-image-reviews
   Looped 2-up (desktop) / 1-up (mobile) review rail.
   Cloned sets for the loop, one stride per arrow click or drag.
   No framework, no storage. */

(function () {
  'use strict';

  var IDLE_MS = 140;
  var IDLE_AFTER_TOUCH_MS = 220;
  var TWEEN_MS = 520;
  var SNAP_MS = 260;
  var DRAG_THRESHOLD = 5;

  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function Reviews(root) {
    this.root = root;
    this.rail = root.querySelector('[data-ir-rail]');
    this.track = root.querySelector('[data-ir-track]');
    this.prevBtn = root.querySelector('[data-ir-prev]');
    this.nextBtn = root.querySelector('[data-ir-next]');
    this.currentEl = root.querySelector('[data-ir-current]');
    this.totalEl = root.querySelector('[data-ir-total]');
    this.liveEl = root.querySelector('[data-ir-live]');
    this.bar = root.querySelector('[data-ir-bar]');
    this.thumb = root.querySelector('[data-ir-thumb]');

    if (!this.rail || !this.track) return;

    this.slides = Array.prototype.slice.call(
      this.track.querySelectorAll('[data-ir-slide]')
    );
    this.count = this.slides.length;

    this.mq = window.matchMedia('(min-width: 750px)');
    this.finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.cloned = false;
    this.animating = false;
    this.dragging = false;
    this.dragMoved = false;
    this.touching = false;
    this.rafScroll = 0;
    this.rafTween = 0;
    this.idleTimer = 0;
    this.resizeTimer = 0;
    this.index = 0;

    this.init();
  }

  /* --- geometry ---------------------------------------------------------- */

  Reviews.prototype.perView = function () {
    return this.mq.matches ? 2 : 1;
  };

  Reviews.prototype.loopable = function () {
    return this.count > this.perView();
  };

  Reviews.prototype.stride = function () {
    var kids = this.track.children;
    if (kids.length < 2) return this.rail.clientWidth || 1;
    var a = kids[0].getBoundingClientRect();
    var b = kids[1].getBoundingClientRect();
    var s = b.left - a.left;
    return s > 1 ? s : this.rail.clientWidth || 1;
  };

  Reviews.prototype.offsetSets = function () {
    return this.cloned ? this.count : 0;
  };

  Reviews.prototype.absIndex = function () {
    var s = this.stride();
    return Math.round(this.rail.scrollLeft / s);
  };

  Reviews.prototype.realIndex = function () {
    if (!this.count) return 0;
    var n = this.absIndex() - this.offsetSets();
    return ((n % this.count) + this.count) % this.count;
  };

  /* --- clones ------------------------------------------------------------ */

  Reviews.prototype.makeClone = function (node) {
    var clone = node.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-ir-clone', '');
    clone.removeAttribute('id');
    clone.removeAttribute('data-block-id');
    clone.removeAttribute('data-shopify-editor-block');
    var focusable = clone.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    for (var i = 0; i < focusable.length; i++) {
      focusable[i].setAttribute('tabindex', '-1');
    }
    return clone;
  };

  Reviews.prototype.buildClones = function () {
    if (this.cloned || !this.loopable()) return;
    var head = document.createDocumentFragment();
    var tail = document.createDocumentFragment();
    var i;
    for (i = 0; i < this.count; i++) head.appendChild(this.makeClone(this.slides[i]));
    for (i = 0; i < this.count; i++) tail.appendChild(this.makeClone(this.slides[i]));
    this.track.appendChild(tail);
    this.track.insertBefore(head, this.track.firstChild);
    this.cloned = true;
  };

  Reviews.prototype.removeClones = function () {
    if (!this.cloned) return;
    var clones = this.track.querySelectorAll('[data-ir-clone]');
    for (var i = 0; i < clones.length; i++) {
      clones[i].parentNode.removeChild(clones[i]);
    }
    this.cloned = false;
  };

  Reviews.prototype.jumpTo = function (realIndex) {
    var s = this.stride();
    this.rail.scrollLeft = (realIndex + this.offsetSets()) * s;
  };

  /* --- motion ------------------------------------------------------------ */

  Reviews.prototype.cancelTween = function () {
    if (this.rafTween) {
      window.cancelAnimationFrame(this.rafTween);
      this.rafTween = 0;
    }
    if (this.animating) {
      this.animating = false;
      this.rail.removeAttribute('data-ir-anim');
    }
  };

  Reviews.prototype.animateTo = function (target, duration) {
    var self = this;
    this.cancelTween();

    if (this.reduce.matches) {
      this.rail.scrollLeft = target;
      this.update();
      this.wrap();
      return;
    }

    var from = this.rail.scrollLeft;
    var delta = target - from;
    if (Math.abs(delta) < 1) {
      this.update();
      return;
    }

    var ms = duration || TWEEN_MS;
    var start = 0;
    this.animating = true;
    this.rail.setAttribute('data-ir-anim', '');

    function step(now) {
      if (!start) start = now;
      var t = Math.min(1, (now - start) / ms);
      self.rail.scrollLeft = from + delta * easeInOutCubic(t);
      if (t < 1) {
        self.rafTween = window.requestAnimationFrame(step);
      } else {
        self.rafTween = 0;
        self.animating = false;
        self.rail.removeAttribute('data-ir-anim');
        self.update();
        self.wrap();
      }
    }

    this.rafTween = window.requestAnimationFrame(step);
  };

  Reviews.prototype.go = function (delta) {
    if (!this.loopable()) return;
    var s = this.stride();
    var target = (this.absIndex() + delta) * s;
    this.animateTo(target);
  };

  /* --- loop wrap --------------------------------------------------------- */

  Reviews.prototype.wrap = function () {
    if (!this.cloned || this.animating || this.dragging || this.touching) return;
    var s = this.stride();
    var abs = Math.round(this.rail.scrollLeft / s);
    if (abs >= this.count && abs < this.count * 2) return;

    var real = ((abs - this.count) % this.count + this.count) % this.count;
    this.rail.scrollLeft = (real + this.count) * s;
    this.update();
  };

  Reviews.prototype.queueWrap = function () {
    var self = this;
    window.clearTimeout(this.idleTimer);
    this.idleTimer = window.setTimeout(function () {
      self.wrap();
    }, this.touching ? IDLE_AFTER_TOUCH_MS : IDLE_MS);
  };

  /* --- state ------------------------------------------------------------- */

  Reviews.prototype.update = function () {
    if (!this.count) return;
    var real = this.realIndex();
    this.index = real;

    if (this.currentEl) this.currentEl.textContent = String(real + 1);
    if (this.totalEl) this.totalEl.textContent = String(this.count);
    if (this.liveEl) {
      this.liveEl.textContent = 'Review ' + (real + 1) + ' of ' + this.count;
    }

    if (this.bar && this.thumb) {
      var trackW = this.bar.clientWidth;
      var thumbW = trackW / this.count;
      var x = Math.min(real * thumbW, Math.max(0, trackW - thumbW));
      this.thumb.style.transform = 'translate3d(' + x + 'px, 0, 0)';
    }

    this.syncSlideVisibility(real);
  };

  Reviews.prototype.syncSlideVisibility = function (real) {
    var per = this.perView();
    for (var i = 0; i < this.count; i++) {
      var slide = this.slides[i];
      var visible = false;
      for (var j = 0; j < per; j++) {
        if ((real + j) % this.count === i) visible = true;
      }
      if (!visible && slide.contains(document.activeElement)) visible = true;

      if (visible) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
      var links = slide.querySelectorAll('a');
      for (var k = 0; k < links.length; k++) {
        if (visible) links[k].removeAttribute('tabindex');
        else links[k].setAttribute('tabindex', '-1');
      }
    }
  };

  /* --- drag -------------------------------------------------------------- */

  Reviews.prototype.onPointerDown = function (e) {
    if (!this.loopable()) return;
    if (!this.finePointer.matches) return;
    if (e.pointerType === 'touch') return;
    if (e.button !== 0) return;

    this.cancelTween();
    this.dragging = true;
    this.dragMoved = false;
    this.dragStartX = e.clientX;
    this.dragStartScroll = this.rail.scrollLeft;
    this.rail.setAttribute('data-ir-drag', '');
    try {
      this.rail.setPointerCapture(e.pointerId);
    } catch (err) {
      /* capture is a nicety, not a requirement */
    }
  };

  Reviews.prototype.onPointerMove = function (e) {
    if (!this.dragging) return;
    var dx = e.clientX - this.dragStartX;
    if (Math.abs(dx) > DRAG_THRESHOLD) this.dragMoved = true;
    this.rail.scrollLeft = this.dragStartScroll - dx;
    e.preventDefault();
  };

  Reviews.prototype.onPointerUp = function (e) {
    if (!this.dragging) return;
    this.dragging = false;
    this.rail.removeAttribute('data-ir-drag');
    try {
      this.rail.releasePointerCapture(e.pointerId);
    } catch (err) {
      /* already released */
    }
    var s = this.stride();
    this.animateTo(Math.round(this.rail.scrollLeft / s) * s, SNAP_MS);
  };

  /* --- reveal ------------------------------------------------------------ */

  Reviews.prototype.observeReveal = function () {
    var self = this;
    if (!('IntersectionObserver' in window)) {
      this.root.setAttribute('data-enter', '');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          if (entry.isIntersecting) {
            self.root.setAttribute('data-enter', '');
          } else if (entry.boundingClientRect.top > 0) {
            self.root.removeAttribute('data-enter');
          }
        }
      },
      { rootMargin: '0px 0px -20% 0px', threshold: 0 }
    );
    io.observe(this.root);
    this.io = io;
  };

  /* --- init -------------------------------------------------------------- */

  Reviews.prototype.init = function () {
    var self = this;

    if (this.count === 0) {
      this.root.setAttribute('data-enter', '');
      return;
    }

    if (!this.loopable()) {
      this.root.setAttribute('data-ir-static', '');
    } else {
      this.root.removeAttribute('data-ir-static');
      this.buildClones();
      this.jumpTo(0);
    }

    this.update();
    this.observeReveal();

    this.rail.addEventListener('scroll', function () {
      if (self.rafScroll) return;
      self.rafScroll = window.requestAnimationFrame(function () {
        self.rafScroll = 0;
        self.update();
      });
      self.queueWrap();
    }, { passive: true });

    this.rail.addEventListener('wheel', function () {
      self.cancelTween();
    }, { passive: true });

    this.rail.addEventListener('touchstart', function () {
      self.touching = true;
      self.cancelTween();
    }, { passive: true });

    this.rail.addEventListener('touchend', function () {
      self.touching = false;
      self.queueWrap();
    }, { passive: true });

    this.rail.addEventListener('pointerdown', function (e) {
      self.onPointerDown(e);
    });
    this.rail.addEventListener('pointermove', function (e) {
      self.onPointerMove(e);
    });
    this.rail.addEventListener('pointerup', function (e) {
      self.onPointerUp(e);
    });
    this.rail.addEventListener('pointercancel', function (e) {
      self.onPointerUp(e);
    });

    /* A drag that ends on a product card must not follow the link. */
    this.rail.addEventListener('click', function (e) {
      if (self.dragMoved) {
        e.preventDefault();
        e.stopPropagation();
        self.dragMoved = false;
      }
    }, true);

    this.rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        self.go(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        self.go(-1);
      }
    });

    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', function () {
        self.go(-1);
      });
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', function () {
        self.go(1);
      });
    }

    /* P15 sitewide 2026-10-23: a resize that keeps the width is the phone
       toolbar collapsing or coming back - the rail does not depend on it. */
    this.vw = document.documentElement.clientWidth;
    this.onResize = function () {
      window.clearTimeout(self.resizeTimer);
      self.resizeTimer = window.setTimeout(function () {
        var w = document.documentElement.clientWidth;
        if (w === self.vw) return;
        self.vw = w;
        self.relayout();
      }, 120);
    };
    window.addEventListener('resize', this.onResize);

    this.onMqChange = function () {
      self.relayout(true);
    };
    if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMqChange);
    else if (this.mq.addListener) this.mq.addListener(this.onMqChange);
  };

  Reviews.prototype.relayout = function (breakpointChanged) {
    this.cancelTween();

    if (breakpointChanged) {
      if (this.loopable()) {
        this.root.removeAttribute('data-ir-static');
        this.buildClones();
      } else {
        this.root.setAttribute('data-ir-static', '');
        this.removeClones();
      }
    }

    this.jumpTo(this.index);
    this.update();
  };

  Reviews.prototype.destroy = function () {
    this.cancelTween();
    window.clearTimeout(this.idleTimer);
    window.clearTimeout(this.resizeTimer);
    if (this.io) this.io.disconnect();
    if (this.onResize) window.removeEventListener('resize', this.onResize);
    if (this.onMqChange) {
      if (this.mq.removeEventListener) this.mq.removeEventListener('change', this.onMqChange);
      else if (this.mq.removeListener) this.mq.removeListener(this.onMqChange);
    }
  };

  /* --- boot -------------------------------------------------------------- */

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-fndry-image-reviews]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      if (root.hasAttribute('data-ir-ready')) continue;
      root.setAttribute('data-ir-ready', '');
      try {
        root.fndryImageReviews = new Reviews(root);
      } catch (err) {
        /* Never let a thrown script hold the section at zero opacity. */
        root.setAttribute('data-enter', '');
        if (window.console && window.console.warn) {
          window.console.warn('fndry-image-reviews failed to init', err);
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-fndry-image-reviews]');
    if (root && root.fndryImageReviews) root.fndryImageReviews.destroy();
  });

  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.closest('[data-fndry-image-reviews]');
    if (!root || !root.fndryImageReviews) return;
    var api = root.fndryImageReviews;
    var id = e.target.getAttribute('data-block-id');
    for (var i = 0; i < api.slides.length; i++) {
      if (api.slides[i].getAttribute('data-block-id') === id) {
        api.cancelTween();
        api.jumpTo(i);
        api.update();
        return;
      }
    }
  });
})();